import React, { useEffect, useState } from "react";
// import Header from "../../Constant/Header/Header";
// import MainSideBar from "../../Constant/MianSideBar/MainSideBar";
import SectionHeader from "../../components/global/SectionHeader"; 
import Layout from "../../components/global/layout";
import { Navigate, useNavigate } from "react-router";

import {
  Form,
  Input,
  Button,
  Typography,
  Col,
  Spin,
  message,
  Row,
  Select,
  Tooltip,
  notification,
} from "antd";
// import { UserOutlined, AlignCenterOutlined } from "@ant-design/icons";
// import {  getEmployee,  getProjects,  getTeams,  getUsers,  projectAddTeam,  userassignlist,} from "../../Api/user/userapi";
import {  getEmployee,  getProjects,  getTeams,  getUsers,  projectAddTeam,  userassignlist,} from "../../api/user/userapi";

const { Option } = Select;

const ProjectAssign = (props) => {
  const [loading, setLoading] = useState(false);
  const [loginErrorMsg, setLoginErrorMsg] = useState("");
  const [id, setId] = useState("");

  const [idTeam, setIdTeam] = useState("");
  const [array, setArray] = useState([]);
  const [arrayTeam, setArrayTeam] = useState([]);
  const [memberarray, setmemberarray] = useState([]);
  const navigate= useNavigate();
  // function handleChange(values) {

  //   setIdTeam(`${values}`)
  // }
  useEffect(() => {
    userDetails();
  }, []);
  const userDetails = async () => {
    try {
      setLoading(true);

      const resp = await getUsers();
      if (resp && resp.status === 200) {
        const list = resp;
        const arrayData = list.data.data;
        const newarraydata = arrayData.filter((item) => {
          return item.role != "HR" && item.role != "subadmin";
        });
        setArrayTeam(newarraydata);
      }
    } catch (e) {
      localStorage.clear();
      navigate("/");
      setTimeout(() => {
        notification.error({
          message: "Unauthorized",
          description: "Your Session Has Expired. Please logIn.",
        });
      }, 1000);
    }
    setLoading(false);
  };

  const employeechange = (event) => {
    setmemberarray(event);
  };

  async function handleChange1(value) {
    const id = value.split(",");

    setId(`${id[0]}`);
    try {
      const resp = await userassignlist(id[0]);
      if (resp && resp.status === 200) {
        const list = resp;
      }
    } catch (e) {}
  }
  const handleSubmit = async (e) => {
    try {
      const data = memberarray.split(",");



      setLoading(true);
      const userResp = await projectAddTeam(id, data[0]);

      form.resetFields();
      
      setTimeout(() => {
        notification.success({
          message: "Project Assigned Successfully.",
        });
      }, 1000);
    } catch (e) {
      setTimeout(() => {
        notification.error({
          message: "Project not Assigned..",
        });
      }, 1000);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProject();
    // getTeam()
  }, []);

  const getProject = async () => {
    try {
      const resp = await getProjects();
      if (resp && resp.status === 200) {
        const list = resp;
        const listing = list.data.data;
        // Not to show the HR
        const newlisting = listing.filter((item) => {
          return item.role != "HR";
        });
        setArray(newlisting);
      }
    } catch (e) {
      setTimeout(() => {
        notification.error({
          message: "Unauthorized",
          description: "Your Session Has Expired. Please logIn.",
        });
      }, 1000);
    }
  };

  const getTeam = async () => {
    try {
      const resp = await getEmployee();
      if (resp && resp.status === 200) {
      }
    } catch (e) {}
  };

  const userassign = async () => {
    try {
      const resp = await userassignlist(id);
      if (resp && resp.status === 200) {
      }
    } catch (e) {}
  };

  const [form] = Form.useForm();
  return (

<Layout>
<div>
  <div className="main-content">
    <div className="d-flex align-items-center justify-content-between headings">
      <SectionHeader title="Asign Projects" />
      {/* <Tooltip title="Add Projects">
      </Tooltip> */}
    </div>

    <div className="container">
            <Spin spinning={loading}>
              <div>
                {loginErrorMsg && message.error(loginErrorMsg)}

                <Form
                  name="normal_login"
                  className="login-form"
                  initialValues={{ remember: true }}
                  onFinish={handleSubmit}
                  form={form}
                >
                  <div className="row">
                    <div
                      span={12}
                      className="col-4"
                    >
                      <Form.Item
                        className="mb-2"
                        name="project"
                        rules={[
                          { required: true, message: "Please Select Project!" },
                        ]}
                      >
                        <Select
                          style={{ width: "100%" }}
                          showSearch={true}
                          placeholder="Select Project..."
                          onChange={handleChange1}
                        >
                          {array &&
                            array.map((item) => (
                              <Option key={[item.id, item.name]}>
                                {item.name}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name="member"
                        rules={[
                          {
                            required: true,
                            message: "Please Select your Employees",
                          },
                        ]}
                      >
                        <Select
                        //  mode="multiple"
                          showSearch={true}
                          isSearchable={true}
                          style={{ width: "100%" }}
                          placeholder="Select Employee"
                          onChange={employeechange}
                        >
                          {arrayTeam &&
                            arrayTeam.map((item) => (
                              <Option key={[item.id, item.fullName]}>
                                {item.fullName}
                                {`     (${item.designation})`}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="login-form-button mt-4style mt-3 "
                      >
                        Submit
                      </Button>
                    </div>
                  </div>

               
                </Form>
              </div>
            </Spin>
          </div>
  </div>

</div>
</Layout>


  );
};

export default ProjectAssign;
